import { Box } from "@mui/material";
import React from "react";

export function GoiPriceDescription({
  padding = "0 auto",
}: {
  padding?: string;
}) {
  return (
    <Box className="caption_12_r gray700" margin={"0 auto"} style={{ padding }}>
      ※ e하늘장사정보시스템을 기반으로 고이장례연구소에서 예상 값을 산출하여
      제공해요
    </Box>
  );
}
